import PropTypes from 'prop-types';
export var AVATAR_TYPE = {
    NONE: 'none',
    SVG_COMPONENT: 'svg-component',
    IMG: 'image',
};
export var AvatarType;
(function (AvatarType) {
    AvatarType["None"] = "none";
    AvatarType["SvgComponent"] = "svg-component";
    AvatarType["Image"] = "image";
})(AvatarType || (AvatarType = {}));
export var AvatarPropType = PropTypes.shape({
    avatarType: PropTypes.oneOf([
        AvatarType.None,
        AvatarType.Image,
        AvatarType.SvgComponent,
    ]),
    imgUrl: PropTypes.string,
    svg: PropTypes.node,
});
export function isImageAvatar(avatar) {
    return avatar.avatarType === AvatarType.Image;
}
export function isNoneAvatar(avatar) {
    return avatar.avatarType === AvatarType.None;
}
export function isSvgAvatar(avatar) {
    return avatar.avatarType === AvatarType.SvgComponent;
}
//# sourceMappingURL=avatar-type.js.map